/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum UserDocumentType {
  Applications = 'applications',
  TrademarkRequests = 'trademark_requests',
}

export function instanceOfUserDocumentType(value: any): boolean {
  for (const key in UserDocumentType) {
    if (Object.prototype.hasOwnProperty.call(UserDocumentType, key)) {
      if (UserDocumentType[key as keyof typeof UserDocumentType] === value) {
        return true
      }
    }
  }
  return false
}

export function UserDocumentTypeFromJSON(json: any): UserDocumentType {
  return UserDocumentTypeFromJSONTyped(json, false)
}

export function UserDocumentTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserDocumentType {
  return json as UserDocumentType
}

export function UserDocumentTypeToJSON(value?: UserDocumentType | null): any {
  return value as any
}
